'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = mapStateToProps;
exports.NotFoundPage = NotFoundPage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// containers

// components
// import Header from '../components/Header';
// import Footer from '../components/Header';
// action creators

function mapStateToProps(state) {
  return {
    i18n: state.i18n
  };
}

function NotFoundPage(props) {
  var i18n = props.i18n;


  return _react2.default.createElement(
    'div',
    null,
    i18n.notfound.title
  );
}

NotFoundPage.propTypes = {
  i18n: _react.PropTypes.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(NotFoundPage);


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFoundPage.js
// module id = 1238
// module chunks = 0